function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.124 23.008A4.002 4.002 0 0 1 16 24a4 4 0 0 1-7.876.992c-.04.005-.082.008-.124.008H2a1 1 0 1 1 0-2h6c.042 0 .083.003.124.008zM24.874 15H30a1 1 0 1 1 0 2h-5.126A4.002 4.002 0 0 1 17 16a4 4 0 0 1 7.874-1zM11 7h19a1 1 0 1 1 0 2H11V7zm-9 8h13v2H2a1 1 0 1 1 0-2zm16 8h12a1 1 0 1 1 0 2H18v-2zM5 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm16 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-9 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
});

var SvgFilters = function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "c63a5ee08b3b1bfd02ceb4908ab1ab81.svg";
export { SvgFilters as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/filters.svg
// module id = null
// module chunks = 